import React from 'react';
import { Outlet } from 'react-router-dom';
import ResponsiveSidebar, { useIsMobile } from './ResponsiveSidebar';
import { useAuth } from '../../contexts/AuthContext';
import { cn, getRoleThemeClass } from '../../lib/utils';
import { Toaster } from '../ui/sonner';
import NotificationCenter from '../common/NotificationCenter';

const MainLayout = () => {
  const { user } = useAuth();
  const { isMobile, isTablet } = useIsMobile();

  return (
    <div className={cn("min-h-screen noise-overlay", getRoleThemeClass(user?.role))}>
      <ResponsiveSidebar />
      
      {/* Main content area - responsive margins */}
      <main className={cn(
        "min-h-screen transition-all",
        isMobile ? "pb-20" : isTablet ? "pt-14" : "ml-64"
      )}>
        {/* Desktop header with notifications */}
        {!isMobile && !isTablet && (
          <header className="sticky top-0 z-30 flex h-14 items-center justify-end gap-4 border-b border-border/40 bg-background/80 backdrop-blur-sm px-6">
            <NotificationCenter />
          </header>
        )}
        
        {/* Content area with responsive padding */}
        <div className={cn(
          "transition-all",
          isMobile ? "p-4 pt-2" : isTablet ? "p-4" : "p-6 lg:p-8"
        )}>
          <Outlet />
        </div>
      </main>
      
      <Toaster position={isMobile ? "top-center" : "top-right"} richColors />
    </div>
  );
};

export default MainLayout;
